<p-dialog [(visible)]="display" [modal]="true" [style]="{ width: '70vw' }"
  [contentStyle]="{ 'max-height': '70vh', 'overflow-y': 'auto' }" (onHide)="closeDialog()" [header]="'showPortfoliosProductsDialog.portfolioProducts' | transloco"
  [closable]="true">

  <!-- Loader: Display while loading -->
  @if (loading) {
    <div class="text-center p-5">
      <p-progressSpinner styleClass="custom-spinner"></p-progressSpinner>
    </div>
  }

  <!-- Main Content: Display when loading is done -->
  @if (!loading) {
    @if ((products?.PortfolioProductsViewModel?.length ?? 0) > 0) {
      <div class="row">
        <!-- Interaction Section with Logo and Helping Text -->
        <div class="justify-content-center mb-3">
          <div class="d-flex flex-column justify-content-center align-items-center">
            <img src="assets/images/thumb_AFP-logo-v02-noTagline-800.png" class="img-fluid" style="max-width: 350px;" [alt]="'showPortfoliosProductsDialog.logo' | transloco">
            <p class="text-center mt-3 mb-0 text-muted" style="font-size: 14px;">
              {{ 'showPortfoliosProductsDialog.exploreHelp' | transloco }}
            </p>
            <p class="text-center mt-3 text-muted" style="font-size: 12px;">
              {{ 'showPortfoliosProductsDialog.clickHelp' | transloco }}
            </p>
          </div>
        </div>
        <!-- Product Grid -->
        @for (item of products?.PortfolioProductsViewModel; track item) {
          <div class="col-2 mb-3">
            <div class="d-flex flex-column align-items-center rounded-3 shadow-sm bg-light h-100 cursor-pointer"
              (click)="naviGateToViewPage(item)">
              <div class="image-container d-flex justify-content-center align-items-center p-2 border-bottom w-100 position-relative">
                <img [src]="item.ArtistProduct.ResizedImageUrl || 'assets/placeholder.png'" [alt]="'showPortfoliosProductsDialog.productImage' | transloco"
                  class="img-fluid rounded" style="max-height: 145px; object-fit: contain;" />
                  <div class="price-badge position-absolute top-0 end-0 m-2 badge px-2 text-white" style="background-color: #178d9b;">
                    {{ item.ArtistProduct.ArtistRevenue || 0 | currency: 'USD' }}
                  </div>
                </div>
                <!-- Product Title -->
                <div class="text-center px-2 py-2 w-100">
                  <h3 class="card-title text-uppercase text-truncate small mb-0">{{ item.ArtistProduct.Name }}</h3>
                </div>
              </div>
            </div>
          }
        </div>
      } @else {
        <p class="text-center p-4 text-muted">{{ 'showPortfoliosProductsDialog.noProductsFound' | transloco }}</p>
      }
    }

    <!-- No Data Message -->
  </p-dialog>
